import { useRef } from "react";
import { Button, Chip } from "@mui/material";
import { AttachFileOutlined } from "@mui/icons-material";
import { ATTACHMENT_RULES, withAddedFiles } from "./supportTicketStatus";

/**
 * Picks images and PDFs for a ticket or reply. Checks the same limits the server enforces and
 * reports the problem instead of adding the file, so a send never fails on an attachment.
 */
const AttachmentPicker = ({ files, onChange, onProblem, disabled }) => {
  const input = useRef(null);

  const add = (event) => {
    const { next, problem } = withAddedFiles(files, Array.from(event.target.files || []));
    event.target.value = "";
    if (problem) {
      onProblem?.(problem);
      return;
    }
    onChange(next);
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        ref={input}
        type="file"
        multiple
        hidden
        accept={ATTACHMENT_RULES.types.join(",")}
        onChange={add}
        data-testid="ticket-attachment-input"
      />
      <Button
        size="small"
        startIcon={<AttachFileOutlined fontSize="small" />}
        disabled={disabled || files.length >= ATTACHMENT_RULES.maxFiles}
        onClick={() => input.current?.click()}
      >
        Attach
      </Button>
      {files.map((file, index) => (
        <Chip
          key={`${file.name}-${index}`}
          size="small"
          label={file.name}
          onDelete={disabled ? undefined : () => onChange(files.filter((_, i) => i !== index))}
        />
      ))}
    </div>
  );
};

export default AttachmentPicker;
